import { useCallback } from "react"
import secureLocalStorage from "react-secure-storage"
import { AvailableLanguages, StorageKeys } from "@utils/user-config"
import { setGlobalLocale } from "@utils/locale"
import { useUserStore } from "./useUserStore"
import { UserProfile } from "@models/userProfile.model"
import { useAgentUpdate } from "@pages/profile-managment/hooks/useAgentService"
import { UpdateAgentRequest } from "@pages/profile-managment/services/agentService"

export const useLocale = () => {
	return (secureLocalStorage.getItem(StorageKeys.USER_PREFERRED_LANGUAGE) ||
		AvailableLanguages.EN_US) as string
}

export function getLocaleStringFromUserProfile(
	user?: UserProfile | null
): string | undefined {
	if (!user?.languageCode || !user?.localeCountryCode) return undefined
	return `${user.languageCode}_${user.localeCountryCode}`.toLowerCase()
}

export function useSetLocale() {
	const { userProfile } = useUserStore()
	const { updateAgent } = useAgentUpdate()

	return useCallback(
		async (next: string) => {
			if (!next?.includes("_")) return

			try {
				if (
					getLocaleStringFromUserProfile(userProfile) !==
					next.toLocaleLowerCase()
				) {
					const [languageCodeRaw, countryCodeRaw] = next.split("_")
					const languageCode = languageCodeRaw.toLowerCase()
					const countryCode = countryCodeRaw.toUpperCase()

					const agentId = userProfile?.agentId

					if (agentId) {
						const payload: UpdateAgentRequest = {
							firstName: userProfile?.agentFirstName,
							lastName: userProfile?.agentLastName,
							languageCode,
							localeCountryCode: countryCode
						}

						await updateAgent({ agentId, payload })
					}
				}

				setGlobalLocale(next)
			} catch (e) {
				console.error(
					"locale update in db failed. No change in local storage.",
					e
				)
			}
		},
		[
			updateAgent,
			userProfile?.agentId,
			userProfile?.agentFirstName,
			userProfile?.agentLastName
		]
	)
}
